(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gl-compare"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('input', (event) => {
  if (!event.target.matches('.gl-compare-range')) return;
  event.target.closest('.gl-compare-slider').style.setProperty(
    '--gl-reveal',
    event.target.value + '%'
  );
});

if (!customElements.get('gl-comparison')) {
  customElements.define('gl-comparison', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      const slider = this.querySelector('.gl-compare-slider');
      const range = this.querySelector('.gl-compare-range');

      if (slider && range) {
        const updateFromX = (clientX) => {
          const bounds = slider.getBoundingClientRect();
          if (!bounds.width) return;

          const value = Math.round(
            Math.max(0, Math.min(100, ((clientX - bounds.left) / bounds.width) * 100))
          );

          range.value = String(value);
          slider.style.setProperty('--gl-reveal', value + '%');
        };

        let startX = 0;
        let startY = 0;
        let direction = null;

        this.onCompareTouchStart = (event) => {
          if (event.touches.length !== 1) return;

          const touch = event.touches[0];
          startX = touch.clientX;
          startY = touch.clientY;
          direction = null;
          updateFromX(touch.clientX);
        };

        this.onCompareTouchMove = (event) => {
          if (event.touches.length !== 1) return;

          const touch = event.touches[0];
          const dx = touch.clientX - startX;
          const dy = touch.clientY - startY;

          if (!direction && Math.max(Math.abs(dx), Math.abs(dy)) > 5) {
            direction = Math.abs(dx) > Math.abs(dy) ? 'horizontal' : 'vertical';
          }

          if (direction !== 'horizontal') return;

          if (event.cancelable) event.preventDefault();
          updateFromX(touch.clientX);
        };

        this.onCompareTouchEnd = () => {
          direction = null;
        };

        slider.addEventListener('touchstart', this.onCompareTouchStart, {
          passive: true,
          capture: true
        });
        slider.addEventListener('touchmove', this.onCompareTouchMove, {
          passive: false,
          capture: true
        });
        slider.addEventListener('touchend', this.onCompareTouchEnd);
        slider.addEventListener('touchcancel', this.onCompareTouchEnd);
      }

      const videos = [...this.querySelectorAll('video')];
      const button = this.querySelector('.gl-comparison-play');
      if (!videos.length || !button) return;

      button.hidden = false;
      let playing = false;

      const stop = () => {
        playing = false;
        videos.forEach(video => video.pause());
        button.textContent = button.dataset.playLabel;
        button.setAttribute('aria-pressed', 'false');
      };

      const start = () => {
        playing = true;
        videos.forEach(video => {
          video.muted = true;
          video.currentTime = 0;
        });
        button.textContent = button.dataset.pauseLabel;
        button.setAttribute('aria-pressed', 'true');
        Promise.all(videos.map(video => video.play())).catch(stop);
      };

      button.addEventListener('click', () => {
        if (playing) stop();
        else start();
      });

      videos.forEach(video => video.addEventListener('ended', () => {
        if (playing) start();
      }));

      this.stop = stop;
      this.onVisibility = () => {
        if (document.hidden) stop();
      };

      document.addEventListener('visibilitychange', this.onVisibility);
      this.observer = new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting) stop();
      });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      const slider = this.querySelector('.gl-compare-slider');

      if (slider) {
        if (this.onCompareTouchStart) {
          slider.removeEventListener('touchstart', this.onCompareTouchStart, true);
        }
        if (this.onCompareTouchMove) {
          slider.removeEventListener('touchmove', this.onCompareTouchMove, true);
        }
        if (this.onCompareTouchEnd) {
          slider.removeEventListener('touchend', this.onCompareTouchEnd);
          slider.removeEventListener('touchcancel', this.onCompareTouchEnd);
        }
      }

      this.stop?.();
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-cover"] && !Shopify.designMode) return;
  try {
    
const selectGrilliantMedia = button => {
 const gallery = document.getElementById(button.dataset.glGallery);
 if (!gallery) return;
 gallery.querySelectorAll('.gl-gallery-panel').forEach(panel => {
  panel.hidden = panel.id !== button.dataset.glPanel;
  if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());
 });
 button.parentElement.querySelectorAll('[data-gl-gallery]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
};
document.addEventListener('click', event => {
 const button = event.target.closest('[data-gl-gallery]');
 if (button) selectGrilliantMedia(button);
});
document.addEventListener('shopify:block:select', event => {
 const button = event.target.closest('[data-gl-gallery]') || event.target.querySelector('[data-gl-gallery]');
 if (button) selectGrilliantMedia(button);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-faq"] && !Shopify.designMode) return;
  try {
    
function openGrilliantQuestion() {
  const target = document.getElementById(window.location.hash.slice(1));
  if (target?.matches('.gl-questions details')) target.open = true;
}
window.addEventListener('hashchange', openGrilliantQuestion);
document.addEventListener('shopify:section:load', openGrilliantQuestion);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openGrilliantQuestion);
else openGrilliantQuestion();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-feature-explorer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('glrf-details')) customElements.define('glrf-details', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.tabs = [...this.querySelectorAll('.glrf-tabs button')];
    this.panels = [...this.querySelectorAll('.glrf-panel')];
    if (!this.tabs.length) return;
    const list = this.querySelector('.glrf-tabs');
    list.hidden = false;
    list.setAttribute('role', 'tablist');
    this.tabs.forEach((tab, i) => {
      tab.setAttribute('role', 'tab');
      this.panels[i].setAttribute('role', 'tabpanel');
      this.panels[i].setAttribute('aria-labelledby', tab.id);
      this.panels[i].tabIndex = 0;
    });
    this.activate(0, false);
    this.addEventListener('click', event => {
      const index = this.tabs.indexOf(event.target.closest('[role="tab"]'));
      if (index >= 0) this.activate(index, false);
    });
    this.addEventListener('keydown', event => {
      const index = this.tabs.indexOf(event.target);
      if (index < 0) return;
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = this.tabs.length - 1;
      if (next !== undefined) { event.preventDefault(); this.activate(next, true); }
    });
    this.onBlockSelect = event => {
      const index = this.panels.findIndex(panel => panel === event.target || panel.contains(event.target));
      if (index >= 0) this.activate(index, false);
    };
    document.addEventListener('shopify:block:select', this.onBlockSelect);
  }
  disconnectedCallback() { document.removeEventListener('shopify:block:select', this.onBlockSelect); this.ready = false; }
  activate(index, focus) {
    this.tabs.forEach((tab, i) => {
      tab.setAttribute('aria-selected', String(i === index));
      tab.tabIndex = i === index ? 0 : -1;
      this.panels[i].hidden = i !== index;
      if (i !== index) this.panels[i].querySelectorAll('video').forEach(video => video.pause());
    });
    if (focus) this.tabs[index].focus();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('.gl-mobile-nav a');
  if (link) link.closest('details').open = false;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-interactive-fit"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('glrf-fit')) customElements.define('glrf-fit', class extends HTMLElement {
 connectedCallback() {
  if (this.fitObserver) return;
  this.addEventListener('submit', this.handleSubmit);
  this.addEventListener('input', this.handleInput);
  this.fitObserver = new MutationObserver(() => this.showForm());
  this.fitObserver.observe(this, {childList: true, subtree: true});
  this.showForm();
  queueMicrotask(() => { if (this.isConnected) this.showForm(); });
 }
 disconnectedCallback() {
  this.fitObserver?.disconnect();
  this.fitObserver = null;
  this.removeEventListener('submit', this.handleSubmit);
  this.removeEventListener('input', this.handleInput);
 }
 showForm() {
  const form = this.querySelector('.glrf-fit-form');
  if (form) form.hidden = false;
 }
 handleInput = () => {
  const result = this.querySelector('.glrf-result');
  if (result) result.hidden = true;
 };
 handleSubmit = event => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.glrf-fit-form')) return;
  event.preventDefault();
  if (!form.reportValidity()) return;
  const result = form.querySelector('.glrf-result');
  if (!result) return;
  const width = Number(form.elements.namedItem('width').value);
  const depth = Number(form.elements.namedItem('depth').value);
  const minWidth = Number(this.dataset.minWidth), maxWidth = Number(this.dataset.maxWidth);
  const minDepth = Number(this.dataset.minDepth), maxDepth = Number(this.dataset.maxDepth);
  if (![width, depth, minWidth, maxWidth, minDepth, maxDepth].every(value => Number.isFinite(value) && value > 0)) return;
  const tooSmall = width < minWidth - 1 || depth < minDepth - 1;
  const tooLarge = width > maxWidth + 1 || depth > maxDepth + 1;
  const belowRange = width < minWidth || depth < minDepth;
  const aboveRange = width > maxWidth || depth > maxDepth;
  let state = 'inside';
  if (tooSmall && tooLarge) state = 'mixed';
  else if (tooLarge) state = 'outside';
  else if (tooSmall) state = 'small';
  else if (belowRange || aboveRange) state = 'close';
  result.dataset.state = state;
  const purchaseLink = result.querySelector('[data-purchase-link]');
  if (purchaseLink) purchaseLink.hidden = state !== 'inside';
  result.querySelector('strong').textContent = this.dataset[state + 'Title'];
  result.querySelector('p').textContent = this.dataset[state];
  result.hidden = false;
 };
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-review"]) return;
  try {
    
document.addEventListener('change', (event) => {
  if (event.target.id !== 'gl-review-width') return;
  const frame = event.target.closest('.gl-review').querySelector('iframe');
  frame.width = event.target.value;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grilliant-presell"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('grilliant-presell')) {
    customElements.define('grilliant-presell', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const range = this.querySelector('[data-range]');
        const frame = this.querySelector('[data-frame]');
        const sticky = this.querySelector('[data-sticky]');
        const hero = this.querySelector('[data-hero]');
        const final = this.querySelector('[data-final]');
        if (range && frame) {
          const update = () => {
            const value = Number(range.value);
            frame.style.setProperty('--glp-position', `${value}%`);
            range.setAttribute('aria-valuetext', `${range.dataset.before}: ${value}%; ${range.dataset.after}: ${100 - value}%`);
          };
          let drag = null;
          const setPosition = (clientX) => {
            const bounds = frame.getBoundingClientRect();
            if (!bounds.width) return;
            range.value = String(Math.round(Math.max(0, Math.min(100, (clientX - bounds.left) / bounds.width * 100))));
            update();
          };
          frame.addEventListener('pointerdown', (event) => {
            if (!event.isPrimary || event.button !== 0) return;
            drag = { id: event.pointerId, x: event.clientX, y: event.clientY, active: event.pointerType === 'mouse' };
            frame.setPointerCapture(event.pointerId);
            if (drag.active) setPosition(event.clientX);
          }, { signal });
          frame.addEventListener('pointermove', (event) => {
            if (!drag || drag.id !== event.pointerId) return;
            const dx = Math.abs(event.clientX - drag.x);
            const dy = Math.abs(event.clientY - drag.y);
            if (!drag.active && dx > 6 && dx > dy) drag.active = true;
            if (drag.active) setPosition(event.clientX);
          }, { signal });
          const finish = (event) => {
            if (!drag || drag.id !== event.pointerId) return;
            if (drag.active && event.type === 'pointerup') this.report('comparison', 'hero');
            drag = null;
            if (frame.hasPointerCapture(event.pointerId)) frame.releasePointerCapture(event.pointerId);
          };
          frame.addEventListener('pointerup', finish, { signal });
          frame.addEventListener('pointercancel', finish, { signal });
          frame.addEventListener('lostpointercapture', finish, { signal });
          range.addEventListener('input', update, { signal });
          range.addEventListener('change', () => this.report('comparison', 'hero'), { signal, once: true });
          update();
        }
        this.addEventListener('click', (event) => {
          const link = event.target.closest('[data-product-cta]');
          if (link && this.contains(link)) this.report('product_click', link.dataset.productCta);
        }, { signal });
        this.querySelectorAll('details').forEach((item) => {
          item.addEventListener('toggle', () => {
            if (item.open) this.report('faq_open', String(Array.from(this.querySelectorAll('details')).indexOf(item) + 1));
          }, { signal });
        });
        if (sticky && hero && final && 'IntersectionObserver' in window) {
          let heroPassed = false;
          let finalVisible = false;
          this.observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
              if (entry.target === hero) heroPassed = entry.boundingClientRect.bottom <= 0;
              if (entry.target === final) finalVisible = entry.isIntersecting;
            }
            const focusedInside = sticky.contains(document.activeElement);
            sticky.hidden = !(heroPassed && !finalVisible) && !focusedInside;
          }, { threshold: 0 });
          this.observer.observe(hero);
          this.observer.observe(final);
        }
      }
      report(action, placement) {
        this.dispatchEvent(new CustomEvent('grilliant:presell', {
          bubbles: true,
          detail: { action, placement, productHandle: this.dataset.productHandle }
        }));
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grilliant-video-proof"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('grilliant-proof-player')) {
  customElements.define('grilliant-proof-player', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const track = this.querySelector('.gl-video-proof__track');
      const videos = Array.from(this.querySelectorAll('.gl-video-proof__video'));
      if (!track || !videos.length) return;
      const mobile = matchMedia('(max-width: 749px)');
      const state = new Map();
      const listeners = [];
      let active = new Set();
      let timer = 0;
      let swipeTimer = 0;
      let swiping = false;
      let disposed = false;
      const listen = (target, event, fn, options) => {
        target.addEventListener(event, fn, options);
        listeners.push(() => target.removeEventListener(event, fn, options));
      };
      const release = video => {
        const item = state.get(video);
        item.generation++;
        item.pending = false;
        video.pause();
        item.poster.hidden = false;
        video.controls = false;
        if (video.hasAttribute('src')) { video.removeAttribute('src'); video.load(); }
        item.button.hidden = false;
        item.button.textContent = 'Play';
        item.message.hidden = true;
      };
      const play = (video, retry = false) => {
        const item = state.get(video);
        if (item.pending || !video.paused) return;
        video.defaultMuted = true;
        video.muted = true;
        video.playsInline = true;
        video.controls = true;
        item.button.hidden = true;
        item.message.hidden = true;
        if (!video.poster) video.poster = item.poster.currentSrc || item.poster.src;
        if (!video.hasAttribute('src') || retry) {
          video.src = video.dataset.src;
          video.load();
        }
        const generation = ++item.generation;
        item.pending = true;
        Promise.resolve(video.play()).catch(error => {
          if (disposed || generation !== item.generation || !active.has(video)) return;
          item.button.hidden = false;
          item.button.textContent = error.name === 'NotAllowedError' ? 'Play' : 'Retry';
          if (error.name !== 'NotAllowedError' && error.name !== 'AbortError') {
            item.message.textContent = 'Unable to load this video. Tap Retry.';
            item.message.hidden = false;
          }
        }).finally(() => {
          if (generation === item.generation) item.pending = false;
        });
      };
      const visible = video => {
        const r = video.getBoundingClientRect();
        const width = Math.max(0, Math.min(r.right, innerWidth) - Math.max(r.left, 0));
        const height = Math.max(0, Math.min(r.bottom, innerHeight) - Math.max(r.top, 0));
        return r.width > 0 && r.height > 0 && width >= r.width * 0.5 && height >= Math.min(r.height * 0.35, innerHeight * 0.35);
      };
      const sync = () => {
        if (disposed || swiping) return;
        let next = document.hidden ? [] : videos.filter(visible);
        if (mobile.matches && next.length > 1) {
          const center = track.getBoundingClientRect().left + track.clientWidth / 2;
          next.sort((a,b) => {
            const ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
            return Math.abs(ra.left + ra.width / 2 - center) - Math.abs(rb.left + rb.width / 2 - center);
          });
          next = next.slice(0,1);
        }
        const previous = active;
        active = new Set(next);
        previous.forEach(video => { if (!active.has(video)) release(video); });
        active.forEach(video => {
          if (!previous.has(video) && (!mobile.matches || this.getAttribute('data-mobile-autoplay') !== 'false')) play(video);
        });
      };
      const schedule = () => { clearTimeout(timer); timer = setTimeout(sync, 100); };
      videos.forEach(video => {
        const button = video.parentElement.querySelector('.gl-video-proof__control');
        const message = video.parentElement.querySelector('.gl-video-proof__status');
        const poster = video.parentElement.querySelector('.gl-video-proof__poster');
        state.set(video, { button, message, poster, generation:0, pending:false });
        listen(video, 'volumechange', () => { if (!video.muted) video.muted = true; });
        listen(video, 'playing', () => {
          if (!active.has(video) || document.hidden) { video.pause(); return; }
          poster.hidden = true;
          button.hidden = true;
          message.hidden = true;
        });
        listen(video, 'error', () => {
          if (!active.has(video)) return;
          poster.hidden = false;
          button.hidden = false;
          button.textContent = 'Retry';
          message.textContent = 'Unable to load this video. Tap Retry.';
          message.hidden = false;
        });
        listen(button, 'click', () => {
          if (mobile.matches) {
            active.forEach(other => { if (other !== video) release(other); });
            active = new Set([video]);
          } else active.add(video);
          play(video, button.textContent === 'Retry');
        });
      });
      listen(track, 'scroll', () => {
        swiping = true;
        clearTimeout(swipeTimer);
        swipeTimer = setTimeout(() => { swiping = false; sync(); }, 180);
      }, { passive:true });
      listen(window, 'scroll', schedule, { passive:true });
      listen(window, 'resize', schedule);
      listen(window, 'pageshow', schedule);
      listen(document, 'visibilitychange', () => {
        if (document.hidden) { active.forEach(release); active.clear(); }
        else schedule();
      });
      this.cleanup = () => {
        disposed = true;
        clearTimeout(timer);
        clearTimeout(swipeTimer);
        listeners.forEach(remove => remove());
        active.forEach(release);
        active.clear();
        this.cleanup = null;
      };
      schedule();
    }
    disconnectedCallback() { if (this.cleanup) this.cleanup(); }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
